const vaultDetailActions = {
  UPDATE_VAULT_ID: 'UPDATE_VAULT_ID',
  UPDATE_ALBUM_FILTER: 'UPDATE_ALBUM_FILTER',
  UPDATE_ALBUM_CUSTOM_FILTERS: 'UPDATE_ALBUM_CUSTOM_FILTERS',
  UPDATE_ALBUMS_SORT_BY: 'UPDATE_ALBUMS_SORT_BY',
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  SET_DASHBOARD_SCOPE: 'SET_DASHBOARD_SCOPE',
  SET_INITIAL_ALBUMS: 'SET_INITIAL_ALBUMS',
  ADD_TO_UNANSWERED: 'ADD_TO_UNANSWERED',
  MOVE_TO_ANSWERED: 'MOVE_TO_ANSWERED',
  MOVE_TO_UNANSWERED: 'MOVE_TO_UNANSWERED',
  DELETE_ANSWERED: 'DELETE_ANSWERED',
  DELETE_UNANSWERED: 'DELETE_UNANSWERED',
  UPDATE_ANSWERED_ALBUM: 'UPDATE_ANSWERED_ALBUM',
  UPDATE_UNANSWERED_ALBUM: 'UPDATE_UNANSWERED_ALBUM',
  SET_ACTIVE_ALBUM: 'SET_ACTIVE_ALBUM',
  CLEAR_ACTIVE_ALBUM: 'CLEAR_ACTIVE_ALBUM',
  REORDER_ANSWERED_ALBUMS: 'REORDER_ANSWERED_ALBUMS',
  REORDER_UNANSWERED_ALBUMS: 'REORDER_UNANSWERED_ALBUMS',
  REQUEST_ALBUMS_REFRESH: 'REQUEST_ALBUMS_REFRESH',
};

export { vaultDetailActions };
